import { render, staticRenderFns } from "./BancoIcon.vue?vue&type=template&id=6900b492&"
import script from "./BancoIcon.vue?vue&type=script&lang=js&"
export * from "./BancoIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports